import {Routes} from '@angular/router';
import {LoginComponent} from './features/credentials/login/login.component';
import {HomeComponent} from './features/home/home.component';
import {authGuard} from './core/guards/auth.guard';

export const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'home', component: HomeComponent, canActivate: [authGuard]},
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {
    path: 'categories',
    loadComponent: () =>
      import ('./features/categories/categories.component').then(module => module.CategoriesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'usuarios',
    loadComponent: () =>
      import ('./features/users/users.component').then(module => module.UsersComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sectors',
    loadComponent: () =>
      import('./features/sectors/sectors.component').then(module => module.SectorsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'cycles',
    loadComponent: () =>
      import('./features/cycles/cycles-main/cycles-main.component').then(module => module.CyclesMainComponent),
    canActivate: [authGuard]
  },
  {
    path: 'product-potential',
    loadComponent: () =>
      import('./features/product-potential/product-potential.component').then(module => module.ProductPotentialComponent),
    canActivate: [authGuard]
  },
  {
    path: 'proceedings',
    loadComponent: () =>
      import('./features/proceedings/proceedings.component').then(module => module.ProceedingsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'proceedings/create',
    loadComponent: () =>
      import('./features/proceedings/components/create-proceedings-consolidator/create-proceedings-consolidator.component')
        .then(module => module.CreateProceedingsConsolidatorComponent),
    canActivate: [authGuard]
  },
  {
    path: 'proceedings/edit/:id',
    loadComponent: () =>
      import('./features/item-profiles/components/create-edit-group-profile/create-edit-group-profile.component')
        .then(module => module.CreateEditGroupProfileComponent),
    canActivate: [authGuard]
  },
  {
    path: 'proceedings/config/:id',
    loadComponent: () =>
      import('./features/item-profiles/components/configure-profile-customer/configure-profile-customer.component')
        .then(module => module.ConfigureProfileCustomerComponent),
    canActivate: [authGuard]
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./features/item-profiles/item-profiles.component').then(module => module.ItemProfilesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'profile/create',
    loadComponent: () =>
      import('./features/item-profiles/components/create-edit-group-profile/create-edit-group-profile.component')
        .then(module => module.CreateEditGroupProfileComponent),
    canActivate: [authGuard]
  },
  {
    path: 'profile/edit/:id',
    loadComponent: () =>
      import('./features/item-profiles/components/create-edit-group-profile/create-edit-group-profile.component')
        .then(module => module.CreateEditGroupProfileComponent),
    canActivate: [authGuard]
  },
  {
    path: 'client',
    loadComponent: () => import('./features/client/client-list/client-list.component')
      .then(module => module.ClientListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'client/create',
    loadComponent: () => import('./features/client/create-edit-client/create-edit-client.component')
      .then(module => module.CreateEditClientComponent),
    canActivate: [authGuard]
  },
  {
    path: 'client/edit/:id',
    loadComponent: () => import('./features/client/create-edit-client/create-edit-client.component')
      .then(module => module.CreateEditClientComponent),
    canActivate: [authGuard]
  },
  {
    path: 'contracts',
    loadComponent: () => import('./features/contracts/contract-list/contract-list.component')
      .then(module => module.ContractListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'contracts/create',
    loadComponent: () => import('./features/contracts/create-edit-contract/create-edit-contract.component')
      .then(module => module.CreateEditContractComponent),
    canActivate: [authGuard]
  },
  {
    path: 'contracts/edit/:id',
    loadComponent: () => import('./features/contracts/create-edit-contract/create-edit-contract.component')
      .then(module => module.CreateEditContractComponent),
    canActivate: [authGuard]
  },
  {
    path: 'contacts',
    loadComponent: () => import('./features/customer-contact/customer-contact.component').then(module => module.CustomerContactComponent),
    canActivate: [authGuard]
  },
  {
    path: 'reports',
    loadComponent: () => import('./features/reports/reports.component').then(module => module.ReportsComponent),
    canActivate: [authGuard]
  }
];
